type TColor = 'primary_100' | 'black_60' | undefined;

export const getTextColor = (disabled: boolean, active: boolean): TColor => {
  switch (true) {
    case disabled:
      return 'black_60';

    case active:
      return 'primary_100';

    default:
      return undefined;
  }
};
